import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function CustomBackdrop(props) {
  const classes = useStyles();
  const { open } = props;

  return (
    <div>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress style={{ color: "#31f4f5" }} />
      </Backdrop>
    </div>
  );
}
